import template from './site-manage-view.html';
import { Column } from '../common/table/model/table-column';

class SiteManageViewController {
  constructor(sitesService, $state, $timeout, $filter, usersService, gettext) {
    'ngInject';

    this.sitesService = sitesService;
    this.$state = $state;
    this.$timeout = $timeout;
    this.$filter = $filter;
    this.usersService = usersService;
    this.gettext = gettext;

    this.assetCols = [
      new Column({
        title: this.gettext('Name'),
        field: 'name',
        sortable: true,
      }),
      new Column({
        title: this.gettext('Make-Model'),
        field: 'makeModel',
        sortable: true,
      }),
      new Column({
        title: this.gettext('Asset Type'),
        field: 'assetType',
        sortable: true,
      }),
      new Column({
        title: this.gettext('Cat-Class'),
        field: 'catClass',
        sortable: true,
      }),
    ];
    this.query = '';
    this.assetsPerPage = 7;
    this.assets = [];
    this.filteredAssets = [];
    this.addedAssets = [];
    this.removedAssets = [];
    this.updateAssetsStatus = '';
  }

  $onInit() {
    this.hasFullControl = this.usersService.hasRequiredFeatures(['sites.manage.create']);
    this.getSite();
  }

  $onDestroy() {}

  getSite() {
    if (!this.siteId) {
      this.updateProperties();
      this.editMode = this.newSite = true;
    } else {
      this.editMode = this.newSite = false;
      this.loading = true;
      this.sitesService
        .getSite(this.siteId)
        .then((s) => {
          this.site = s;
          this.updateProperties(s);
          this.sitesService
            .getSiteAssetsByIds(s.assets)
            .then((assets) => {
              this.setAssets(assets);
            })
            .finally((_) => {
              this.loading = false;
            });
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  setAssets(assets) {
    this.assets = assets;
    this.handleQueryChange();
  }

  updateProperties(site = {}) {
    const { name, description, address, assets, users, geoZone } = site;
    this.meta = {
      name,
      description,
      address,
    };
    this.users = users || [];
    this.geoZone = geoZone;
  }

  createSite() {
    if (this.meta.name) {
      this.status = 'creating';
      this.error = '';
      const site = {
        ...this.meta,
        geoZone: this.geoZone,
      };

      const assetIds = this.assets.map((item) => item.id);

      this.sitesService
        .createSite(site, assetIds, this.users)
        .then((s) => {
          this.site = s;
          this.siteId = this.site.id;
          this.$state.go('sites.view', { id: this.site.id });
        })
        .catch((error) => {
          const { status } = error || {};
          if (status === 409) {
            this.error = this.gettext('Site name already in use');
          } else {
            this.error = this.gettext('Error creating the site');
          }
        })
        .finally((_) => {
          this.status = '';
        });
    }
  }

  openAssetSelector() {
    this.sitesService.openAssetSelector(this.assets).then((res) => {
      this.addedAssets = res.added;
      this.removedAssets = res.removed;

      if (this.addedAssets.length > 0 || this.removedAssets.length > 0) {
        let promise;

        this.updateAssetsStatus = 'updating';

        if (this.siteId) {
          promise = this.sitesService
            .updateSiteAssets(this.siteId, this.addedAssets, this.removedAssets)
            .then(() => this.sitesService.getSite(this.siteId))
            .then((s) => {
              this.site = s;
              this.updateProperties(s);
              return this.sitesService.getSiteAssetsByIds(s.assets);
            });
        } else {
          const assetIds = Object.keys(res.result);

          promise = this.sitesService.getSiteAssetsByIds(assetIds);
        }

        promise
          .then((assets) => {
            this.setAssets(assets);
          })
          .catch(() => {
            this.updateAssetsStatus = 'error';
          })
          .finally(() => {
            this.updateAssetsStatus = '';
          });
      }
    });
  }

  onGeoZoneChanged(geometry) {
    this.geoZone = geometry;
    if (!this.newSite) {
      this.updateSite('geoZone');
    }
  }

  updateSite(key) {
    const updated =
      key === 'meta' ? this.meta : this.hasFullControl ? { geoZone: this.geoZone } : {};
    this.status = `updating-${key}`;
    const site = {
      ...this.site,
      ...updated,
    };
    this.sitesService
      .updateSite(site)
      .then((s) => {
        this.siteId = this.site.id;
        this.getSite();
        this.status = '';
      })
      .catch((error) => {
        this.status = 'update-error';
        const { status } = error || {};
        if (status === 409) {
          this.update_error = this.gettext('Site name already in use');
        } else {
          this.update_error = this.gettext('Error updating the site');
        }
      });
  }

  deleteSite() {
    this.sitesService
      .deleteSite(this.site)
      .then(() => {
        this.onClose();
        this.$state.go('sites.list');
      })
      .catch((_) => {});
  }

  openUsersSelector() {
    this.sitesService
      .openUsersSelector(this.users, this.users)
      .then(({ added, removed, finalUsers }) => {
        if (this.newSite) {
          this.users = finalUsers;
        } else if (added.length || removed.length) {
          this.updateUsersStatus = 'updating-users';
          this.sitesService
            .updateSiteUsers(this.site.id, added, removed)
            .then(() => {
              this.getSite();
            })
            .catch(() => {
              this.updateUsersStatus = 'updating-users-error';
            })
            .finally((_) => {
              this.updateUsersStatus = '';
            });
        }
      })
      .catch((_) => {});
  }

  handleQueryChange() {
    this.filteredAssets = this.$filter('filter')(this.assets, this.query);
  }
}

export default {
  template,
  controller: SiteManageViewController,
  controllerAs: 'siteMVm',
  bindings: {
    siteId: '<',
    onClose: '&',
  },
};
